import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Button, Col, Form, Input, message, Popconfirm, Row } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import Utils from '../../../Assets/Scripts/Utils';
import {
  applyRegisterCustomFields,
  createRegisterShowField,
  RegisterLayoutBody,
  useRegisterFieldLayout,
} from '../../../Components/ResourceFieldLayout/RegisterFieldLayout';
import { api } from '../../../Services/axiosService';

function OccurrenceTypeRegister() {
  const { id: editId } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [screenModified, setScreenModified] = useState(false);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const { fieldLayout, roleId } = useRegisterFieldLayout('OccurrenceType');
  const showField = createRegisterShowField(fieldsPermissions, fieldLayout, roleId);

  const fetchOccurrenceTypeEdit = async (id) => {
    setLoading(true);

    const res = await api
      .get(`/OccurrenceType?id=${id}`)
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os dados!');
      });

    form.setFieldsValue(applyRegisterCustomFields(res));
    setLoading(false);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const httpMethod = editId ? 'put' : 'post';
    await api[httpMethod]('/OccurrenceType', values)
      .then(() => {
        message.success(`Dados ${editId ? 'atualizados' : 'salvos'}!`);
        form.resetFields();

        if (editId) {
          fetchOccurrenceTypeEdit(editId);
        }

        setLoading(false);
        setScreenModified(false);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Erro ao enviar os dados do Tipo de Ocorrência!');
        setLoading(false);
      });
  };

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields }) => {
        if (name === 'OccurrenceType') {
          fields.forEach(({ name, access, isRequired }) => {
            permissions[name] = { access, isRequired };
          });
        }
      }
    );
    setFieldsPermissions(permissions);
  }, []);

  useEffect(() => {
    if (editId) {
      fetchOccurrenceTypeEdit(editId);
    }
  }, []);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      onChange={() => setScreenModified(true)}
      style={{ maxWidth: '100%', margin: '0 auto' }}
    >
      <div className="form-toolbar">
        {screenModified && (
          <Popconfirm
            title="Deseja mesmo voltar?"
            onConfirm={() => navigate(-1)}
            okText="Sim"
            cancelText="Não"
          >
            <Button>Voltar</Button>
          </Popconfirm>
        )}
        {!screenModified && <Button onClick={() => navigate(-1)}>Voltar</Button>}
        <Button loading={loading} block type="primary" htmlType="submit">
          Salvar
        </Button>
      </div>

      {/* Campos invisiveis */}
      <Form.Item className="input-hidden" label="Id" name="id">
        <Input />
      </Form.Item>

      <Row gutter={[24]}>
        <RegisterLayoutBody
          fieldLayout={fieldLayout}
          fieldsPermissions={fieldsPermissions}
          roleId={roleId}
          widgetMap={{
            Name: () =>
              showField('Name') && (
                <Col span={8}>
                  <Form.Item
                    label="Nome"
                    name="name"
                    rules={[
                      {
                        required: fieldsPermissions?.Name?.isRequired,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <Input disabled={fieldsPermissions?.Name?.access !== 2} />
                  </Form.Item>
                </Col>
              ),
          }}
          form={form}
          loading={loading}
          padraoFields={
            showField('Name') && (
              <Col span={8}>
                <Form.Item
                  label="Nome"
                  name="name"
                  rules={[
                    {
                      required: fieldsPermissions?.Name?.isRequired,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Input disabled={fieldsPermissions?.Name?.access !== 2} />
                </Form.Item>
              </Col>
            )
          }
        />
      </Row>
    </Form>
  );
}

export default OccurrenceTypeRegister;
